/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Peaks_Info_PathInputs */



/**
* | output |
* | --- |
* | "Peaks Info Path" |
*
* @param {Peaks_Info_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const peaks_info_path = /** @type {((inputs?: Peaks_Info_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Peaks_Info_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chemin des pics")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gipfel-Infopfad")
	if (locale === "it") return /** @type {LocalizedString} */ ("Percorso informativo sulle cime")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информационный путь к вершинам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ruta de información de Peaks")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Peaks 信息路径")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ピークス情報パス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पीक्स इन्फो पाथ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações sobre os picos")
	return /** @type {LocalizedString} */ ("Peaks Info Path")
});